exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".factoring__buttons {\n  height: 19.5rem;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  margin-bottom: 6rem;\n}\n\n.factoring__buttons>button:first-child {\n  text-transform: uppercase;\n}\n\n.factoring__buttons>span {\n  white-space: pre-wrap;\n}\n\n", ""]);

// exports
